import { D3YScale } from '@shared/types/common-graph.types';

import { ChartStackedBarBarConfig } from '../chart.view-model';

export const getBarData = <Data extends object>(
  data: Data,
  bars: ChartStackedBarBarConfig<Data>[],
  yScale: D3YScale
): {
  barHeights: number[];
  restSpace: number;
  barYs: number[];
} => {
  const barHeights = bars.map((bar) => {
    const barValue = data[bar.dataKey] as number;
    return yScale(0) - yScale(barValue);
  });

  const restSpace = barHeights.reduce((acc, height) => acc - height, yScale(0));
  const barYs = barHeights.map((_, idx) => {
    return restSpace + barHeights.slice(0, idx).reduce((acc, h) => acc + h, 0);
  });

  return {
    barHeights,
    restSpace,
    barYs,
  };
};
